<style>
.typewriter-title {
    display: inline-block;
    position: relative;
}

.fade-in-element {
    opacity: 0;
    animation: fadeInAnimation 0.3s ease-in-out forwards;
}

@keyframes fadeInAnimation {
    from {
        opacity: 0;
        transform: translateY(-2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

</style>

<div class="px-3">
    <h4 class="fs-6 b-0 typewriter-title"><%= title %></h4>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <% if ( breadcrumb && breadcrumb.length > 0 ) { %>
                <% for ( let bi = 0; bi < breadcrumb.length; bi++ ) { %>
                    <li class="breadcrumb-item <% if (bi === breadcrumb.length - 1) { %>active<% } %>" <% if (bi === breadcrumb.length - 1) { %>aria-current="page"<% } %>>
                        <%= breadcrumb[ bi ]; %>
                    </li>
                <% }    %>
            <% } %>
        </ol>
    </nav>
</div>